import React from 'react';
import { Switch } from 'react-router';
import PrivateRoute from '../../components/PrivateRoute.tsx';
import TermListPage from './TermListPage.js';
import TermForm from 'components/term/TermForm.js';
export default () => (
  <Switch>
    <PrivateRoute
      exact
      path="/etapas"
      permission="academico.can_view_term"
      component={TermListPage}
    />
    <PrivateRoute
      exact
      path="/etapas/:id/edit"
      permission="academico.can_change_term"
      component={TermForm}
    />
    <PrivateRoute
      exact
      path="/etapas/new"
      permission="academico.can_add_term"
      component={TermForm}
    />
  </Switch>
);
